<style lang="stylus">
    .edit-library-container
        .dialog-slot
            padding-top 16px;
        .edit-wrap
            width 592px
            // padding 15px
            .library-select

                display flex
                align-items center
                margin-bottom 22px
                .ivu-input
                    height 40px
                    line-height 40px
                    padding-left 12px;
                    background-color var(--bg-color-primary)
                    color var(--text-color-primary)
                span,p
                    white-space nowrap
                p
                    overflow hidden
                    text-overflow ellipsis
                    flex 1
                    color var(--text-color-primary)
                    border 1px solid var(--border-color-box-6);
                    height 40px
                    line-height 40px
                    border-radius 6px;
                    padding-left 12px
            .library-shape-list
                width 592px;
                height 252px
                padding-top 4px
                // padding-right 6px;
                // padding 8px 8px 0 8px;
                margin-bottom 30px
                // overflow auto
                // overflow-x hidden
                overflow-y auto;
                overflow-x hidden
                &.empty
                    display flex
                    align-items center
                    justify-content center
                .empty
                    width 160px;
                    display flex;
                    flex-direction column;

                    img
                        height 120px;
                        width 160px;
                    .empty-text
                        margin-top 6px;
                        text-align center
                        color: rgba(0, 0, 0, 0.5)
                .vuedrag-wrap
                    // padding-top 4px
                    display grid;
                    grid-gap 18px;
                    grid-template-columns repeat(9, 1fr);
                .mydb-content-item
                    position relative
                    float left
                    display: flex;
                    width: 48px;
                    height: 48px;
                    justify-content: center;
                    align-items: center;
                    border-radius: 6px;
                    background: var(--bg-color-library-shape);
                    &:hover
                        background: var(--bg-color-left-panel-library-shape-hover);
                        .icon-del
                            display block;
                            fill: var(--svg-color-delete-file-fill);
                            stroke: var(--svg-color-delete-file-stroke);
                    &.mydb-item-add
                        user-select none
                        cursor pointer
                        padding: 2px
                        background: var(--bg-color-tertiary);
                        &:hover
                            background: var(--bg-color-left-panel-library-shape-hover);
                            .mydb-item-img
                                svg
                                    opacity 1
                        .mydb-item-img
                            border 2px dashed  var(--border-color-add-my-db-symbol)
                            border-radius 6px;
                            position relative
                            width 44px
                            height 44px
                            display flex;
                            align-items center
                            justify-content center
                            svg
                                width 16px;
                                height 16px
                                color var(--svg-color-primary);
                                opacity 0.6
                    .mydb-item-img
                        width 32px
                        height 32px
                        img
                            width 100%
                            height 100%
                            object-fit contain
                    .mydb-item-text
                        height 20px
                        width 100%
                        font-size 12px
                        margin-top 5px
                        color #353535
                        text-align center
                        line-height 20px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    .icon-del
                        display none
                        position absolute
                        top -4px
                        right -3px
                        cursor pointer
                        z-index 1
                        width 16px
                        height 16px


        .dialog-btnbox-normal
            position relative
            height 28px;
            div
                height 28px;
                line-height 28px
            .delete-library
                background-color var(--bg-color-tertiary)
                position absolute
                left 0;
                margin 0;
                border 1px solid var(--border-color-gray2)
                border-radius 6px;
                padding-left 12px;
                color var(--text-color-primary)
                svg
                    width 24px;
                    height 24px;
                    color var(--svg-color-primary)
                    margin-right 4px
            .dialog-btn-ok
                right 0
                &.loading
                    position relative
                    cursor not-allowed;
                    .ivu-icon
                        position absolute;
                        left 8px
    .editLibrary-mask
        position fixed
        left 0
        top 0
        width 100vw
        height 100vh
        z-index 30
</style>

<template>
    <div>
        <Dialog :title="$t('title')" :isShow="true" :mask="true" :extra="true" class="edit-library-container" @close="close">
            <div class="edit-wrap">
                <div class="library-select">
                    <!-- <span>{{ $t("name") }}：</span> -->
                    <Input
                        ref="nameInput"
                        :maxlength="32"
                        v-if="mydbEdit"
                        v-show="inputShow"
                        v-model="name"
                        @keyup.native.enter="inputShow = false"
                        @on-blur="inputShow = false"
                    />
                    <p @dblclick="handEdit" @click="handEdit" v-if="mydbEdit" v-show="!inputShow" class="can-edit">{{ name }}</p>

                    <p v-if="!mydbEdit" class="normal">{{ name }}</p>
                </div>

                <div class="library-shape-list">
                    <!-- <template v-if="librarySelectShape.length">
                    </template> -->

                    <vuedraggable class="vuedrag-wrap" v-model="librarySelectShape" v-bind="{ scroll: true, animation: 300 }">
                        <div class="mydb-content-item mydb-item-add" @click="showImportModal = true">
                            <div class="mydb-item-img" v-tippy="{ placement: 'bottom-center', arrow: true }" :content="$t('importMenu')">
                                <iconSymbol class="item-icon" name="add-my-symbol" />
                            </div>
                        </div>
                        <div
                            class="mydb-content-item"
                            v-for="(item, index) in librarySelectShape"
                            :key="index"
                            :title="item.name"
                            :content="item.name"
                            v-tippy="{ placement: 'top', arrow: true }"
                        >
                            <iconSymbol class="icon-del" name="delete-file" @click.native="() => delSymbol(index)" />
                            <div class="mydb-item-img">
                                <img :src="item.url" alt="" />
                            </div>
                        </div>
                    </vuedraggable>
                    <!-- <template v-else>
                        <div class="empty">
                            <img :src="require('@/app/assets/empty-library.png')" alt="" />
                            <div class="empty-text">{{ $t("emptyText", { keyWord: name }) }}</div>
                        </div>
                    </template> -->
                </div>
            </div>
            <div class="dialog-btnbox-normal">
                <div
                    class="delete-library"
                    v-if="librarySelectShape.length"
                    @click="handleClear"
                    :content="$t('deleteNewDb')"
                    v-tippy="{ placement: 'bottom' }"
                >
                    <iconSymbol name="delete-library" />
                    <span class="clear-text">
                        {{ $t("deleteNewDb") }}
                    </span>
                </div>
                <div class="dialog-btn-ok" :class="{ loading: isSubmitting }" @click="confirm">
                    <i v-show="isSubmitting" class="ivu-icon ivu-icon-ios-loading ivu-load-loop"></i>
                    {{ $t("confirm") }}
                </div>
            </div>
        </Dialog>
        <div class="editLibrary-mask" v-show="isSubmitting"></div>
        <ImportLibrary v-if="showImportModal" @closeModal="showImportModal = false" type="toEdit" @toEdit="addSymbolFromUpload" />
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Inject, Watch } from "vue-property-decorator";
    import Dialog from "./../Dialog.vue";
    import vuedraggable from "vuedraggable";
    import ImportLibrary from "@/app/components/Modals/library/ImportLibrary.vue";
    import appConfig from "@/public/globalConfig";
    import head from "lodash/head";
    import omit from "lodash/omit";
    import merge from "lodash/merge";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
            vuedraggable,
            ImportLibrary,
        },
    })
    export default class EditLibrary extends Vue {
        @Inject()
        ["showMessage"];
        librarySelectShape = [];
        showImportModal: boolean = false;
        worker: any;
        userWorkerURL: string = appConfig.userWorkerURL;
        name = "";
        inputShow = false;
        mydbEdit = true;
        removeLoadingFunc = null;
        isSubmitting = false;
        actionBlock = false;
        // 收藏符号库列表
        get editLibrary() {
            return this.$store.state.library.editLibrary;
        }

        get collectTBID() {
            return this.$store.state.library.collectTBID;
        }

        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        get ossList() {
            return this.$store.state.library.ossList;
        }

        set ossList(v) {
            this.$store.commit("setLibraryState", {
                type: "ossList",
                data: v,
            });
        }

        //生成初始选中
        created() {
            this.mydbEdit = this.collectTBID !== this.editLibrary.id;
            this.librarySelectShape = this.editLibrary.data.map((item) => ({
                ...omit(item, ["shape"]),
                data: item.shape,
                url: item.url,
            }));
            this.name = this.mydbEdit ? this.editLibrary.title : this.editLibrary[this.lang] ? this.editLibrary[this.lang] : this.editLibrary.title;
            this.$bus.$on("msgOperation", (data) => {
                if (data.sponsor == "deleteMyDbTable" && data.data) {
                    // this.deleteTable();
                    this.clearTable();
                }
            });
            this.$once("hook:beforeDestroy", () => {
                this.$bus.$off("msgOperation");
            });
        }
        clearTable() {
            this.librarySelectShape = [];
        }

        handEdit() {
            this.inputShow = true;
            this.$nextTick(() => {
                (<any>this.$refs.nameInput).focus();
            });
        }
        delSymbol(index) {
            this.librarySelectShape.splice(index, 1);
        }
        addSymbolFromUpload(data) {
            let list = data.map((item) => {
                return {
                    blob: item.blob,
                    data: item.data,
                    name: item.name,
                    url: URL.createObjectURL(item.blob),
                };
            });
            this.librarySelectShape.push(...list);
        }
        handleClear() {
            let msg = this.$t("remindDelete") as string;
            this.showMessage({
                sponsor: "deleteMyDbTable",
                type: 0,
                content: msg,
                confirmText: this.$t("clear"),
                confirmType: "warning",
            });
        }

        deleteTable() {
            // 删除自定义表
            if (this.actionBlock) return;
            this.actionBlock = true;

            let userInfo = this.$store.state.user.userInfo;
            this.worker = new Worker(this.userWorkerURL);
            const { group: DBName, title: tableName, id: tableID } = this.editLibrary;

            let tempList = this.ossList.slice(0);

            let uploadStoreInfo = () => {
                let menu = JSON.parse(JSON.stringify(this.$store.state.library.menuList));
                let checkbox = JSON.parse(JSON.stringify(this.$store.state.library.checkbox));

                let arr = checkbox[DBName];
                for (let i = 0; i < arr.length; i++) {
                    // 移除checkbox选中框
                    if (arr[i] == tableID) {
                        arr.splice(i, 1);
                        break;
                    }
                }

                for (let i = 0; i < menu.length; i++) {
                    // 删除菜单列表
                    if (menu[i].groupName == DBName) {
                        let children = menu[i].children;
                        for (let j = 0; j < children.length; j++) {
                            if (children[j].id == tableID) {
                                menu[i].children.splice(j, 1);
                            }
                        }
                    }
                }

                this.$store.commit("setLibraryState", {
                    type: "checkbox",
                    data: checkbox,
                });

                this.$store.commit("setLibraryState", {
                    type: "menuList",
                    data: menu,
                });
            };

            this.worker.postMessage({
                type: "deleteTable",
                urls: this.urls,
                data: {
                    DBName: DBName,
                    tableName: tableName,
                    tableID: tableID,
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                },
            });
            this.worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "deleteTableOK") {
                    let ts: any = this;
                    this.worker.terminate();
                    ts.$bus.$asyncEmit("uploadToCloud", {
                        message: {
                            type: "deleteLib",
                            isUserDB: true,
                            data: {
                                tableID,
                            },
                        },
                    });
                    uploadStoreInfo();
                    let deleteID = -1;
                    let symbol_key = "";

                    for (let i = 0; i < tempList.length; i++) {
                        if (tempList[i].table_id == tableID) {
                            deleteID = tempList[i].id;
                            symbol_key = tempList[i].symbol_key;
                            tempList.splice(i, 1);
                            break;
                        }
                    }
                    if (deleteID != -1) {
                        this.$edApi
                            .deleteCustomLibrary({ id: userInfo.user_id, token: userInfo.token, libs: deleteID, symbol_key })
                            .then((e) => {
                                this.ossList = tempList;
                                this.actionBlock = false;
                                this.close();
                                console.log("delete success ", deleteID, tempList);
                            })
                            .catch((e) => {
                                this.actionBlock = false;
                                console.log("delete fail");
                            });
                    } else {
                        this.actionBlock = false;
                        this.close();
                    }
                }
            };
        }

        confirm() {
            const { group: dbName, title: tableName, id: tableID } = this.editLibrary;
            let insertData = this.librarySelectShape.map((item, i) => {
                return {
                    ...omit(item, ["url"]),
                    index: i,
                    next: this.librarySelectShape.length - 1 == i ? null : i + 1,
                };
            });
            if (this.name.trim() == "") {
                this.name = tableName;
            }
            this.addSymbolsToDB(dbName, tableName, tableID, insertData);
        }

        // 清除库且添加多个符号到库
        addSymbolsToDB(dbName, oldTbName, tableID, insertData) {
            let repeatedRemind = {
                // 放在worker里不能使用$t翻译
                type: 2,
                imgType: 2,
                time: 3,
                content: this.$t("repeatedName"),
            };
            if (this.collectTBID !== tableID && this.name === "我的收藏") {
                this.name = oldTbName;
                this.showMessage(repeatedRemind);
                return;
            }

            if (this.isSubmitting) {
                return;
            }
            this.isSubmitting = true;
            // this.removeLoadingFunc = this.$edMessage.loading(
            //     this.$t("loading")
            // );
            this.worker = new Worker(this.userWorkerURL);
            if (this.name.trim() === "") {
                this.name = oldTbName;
            }

            let updateData = {
                DBName: dbName,
                tableName: oldTbName,
                tableID: tableID,
                insertData: insertData,
                versionDB: `myDBVersion_${this.userInfo.user_id}`,
                newTbName: this.name,
            };

            let newTbName = this.name;
            let notRename = this.collectTBID === tableID || oldTbName === newTbName;

            if (notRename) {
                this.worker.postMessage({
                    type: "removeAndUpdateTable",
                    urls: this.urls,
                    data: updateData,
                });
            } else {
                this.worker.postMessage({
                    type: "renameAndUpdateTable",
                    urls: this.urls,
                    data: updateData,
                });
            }

            this.worker.onmessage = (e) => {
                let message = e.data;

                if (message.type === "updateOK") {
                    if (notRename) {
                        this.$bus.$emit("setLibrary", {
                            type: "updateLibrary",
                            groupName: dbName,
                            tableID,
                        });
                        this.$bus.$asyncEmit("uploadToCloud", { message }).then((e) => {
                            let version = e.data.version;
                            this.worker.postMessage({
                                type: "setVersion",
                                urls: this.urls,
                                data: {
                                    versionDB: `myDBVersion_${this.userInfo.user_id}`,
                                    tableID: tableID,
                                    version,
                                    params: {
                                        updateModified: notRename,
                                    },
                                },
                            });

                            // this.removeLoadingFunc()
                            // this.close()
                            this.isSubmitting = false;
                        });
                        this.$store.commit("setLibraryDisplayList", {
                            groupName: dbName,
                            tableName: oldTbName,
                            data: [],
                        });
                    } else {
                        this.uploadStoreInfo(oldTbName, newTbName, tableID);
                        this.uploadRenameLibToCloud(message);
                    }
                } else if (message.type === "renameError") {
                    this.worker.terminate();

                    this.isSubmitting = false;
                    // this.removeLoadingFunc()
                    this.showMessage(repeatedRemind);
                    this.name = oldTbName;
                } else if (message.type === "setVersionOK") {
                    this.worker.terminate();
                }
            };
        }

        async uploadRenameLibToCloud(message) {
            let userInfo = this.userInfo;
            let DB = message.data.group;
            let TB = message.data.name;
            let tableID = message.data.tableID;

            let deleteID = -1;
            let updateID = -1;
            let symbol_key = "";

            let versionData = {
                vTableName: `myDBVersion_${userInfo.user_id}`,
                vTableID: message.data.tableID,
            };

            for (let i = 0; i < this.ossList.length; i++) {
                if (this.ossList[i].table_id == tableID) {
                    deleteID = this.ossList[i].id;
                    updateID = this.ossList[i].id;
                    symbol_key = this.ossList[i].symbol_key;
                    break;
                }
            }

            // 获取库的数据
            let files = await window["_view"].saveLib(DB, TB, versionData);
            let fileSize = files[0].file.size + files[1].file.size;

            // 将edt文件传入oss
            let e = await this.$bus.$asyncEmit("uploadToCloud", { message });

            // 重命名
            if (updateID != -1) {
                this.$edApi
                    .updateCustomLibrary({
                        id: userInfo.user_id,
                        token: userInfo.token,
                        lid: updateID,
                        name: TB,
                        version: message.data.version,
                        tableID: message.data.tableID,
                        symbol_key,
                    })
                    .then((e) => {
                        let version = e.data.version;
                        this.worker.postMessage({
                            type: "setVersion",
                            urls: this.urls,
                            data: {
                                versionDB: `myDBVersion_${userInfo.user_id}`,
                                tableID: tableID,
                                version,
                                params: {
                                    updateModified: false,
                                },
                            },
                        });
                        console.log("update table success");
                    });
            }

            // 删除oss的旧表
            // if(deleteID != -1){
            //     await this.$edApi.deleteCustomLibrary({id: userInfo.user_id,token: userInfo.token,libs: deleteID, symbol_key})
            // }

            // 更新osslist
            let { data: ossList } = await this.$edApi.getCustomLibraryList({
                id: userInfo.user_id,
                token: userInfo.token,
                type: 0,
            });
            this.$store.commit("setLibraryState", {
                type: "ossList",
                data: ossList,
            });

            // this.removeLoadingFunc()
            this.close();
            this.isSubmitting = false;
        }

        uploadStoreInfo(oldTbName, newTbName, tableID) {
            let menu = this.$store.state.library.menuList; // 更新用户自定义库的表名
            let dbName = this.$store.state.library.extraDB[2];
            let showList = this.$store.state.library.displayList;

            for (let i = 0; i < menu.length; i++) {
                if (menu[i].groupName == dbName) {
                    let children = menu[i].children;
                    for (let j = 0; j < children.length; j++) {
                        if (children[j].tableName == oldTbName) {
                            menu[i].children[j].tableName = newTbName;
                        }
                    }
                }
            }

            for (let i = 0; i < showList.length; i++) {
                if (showList[i].groupName == dbName) {
                    let children = showList[i].children;
                    for (let j = 0; j < children.length; j++) {
                        if (children[j].tableName == oldTbName) {
                            showList[i].children[j].tableName = newTbName;
                        }
                    }
                }
            }
            this.$bus.$emit("setLibrary", {
                type: "updateLibrary",
                groupName: dbName,
                tableID,
            });

            this.$store.commit("setLibraryDisplayList", {
                groupName: dbName,
                tableName: newTbName,
                data: [],
            });

            this.$store.commit("setStatus", {
                type: "selectLibrary",
                data: [dbName, newTbName, tableID],
            }); // 主要为了更新新的表名
        }

        get showEditModal() {
            return this.$store.state.library.showEditModal;
        }
        close() {
            console.log(1111111111111);
            this.$store.commit("setLibraryState", {
                type: "showEditModal",
                data: false,
            });
            this.$store.commit("setDialogState", {
                type: "showDialogMask",
                data: false,
            });
        }
    }
</script>
<i18n>
{
  "zh": {
    "name": "符号库名称",
    "title": "编辑符号库",
    "confirm": "完成",
    "cancel": "关闭",
    "del": "删除",
    "importMenu": "导入",
    "loading": "加载中...",
    "nullName": "库名不可为空",
    "repeatedName": "库名不可重复",
    "remindDelete": "即将清空符号库，该操作无法撤销。",
    "emptyText": "{keyWord}还没有添加形状",
    "deleteNewDb": "清空符号库",
    "clear": "清空"
  },
  "en": {
    "name": "name",
    "title": "Edit Shapes Library",
    "confirm": "OK",
    "cancel": "Cancel",
    "del": "Delete",
    "importMenu": "Drop here or click to import",
    "loading": "loading...",
    "nullName": "Library Name cannot be empty.",
    "repeatedName": "Library Name Cannot Be Repeated",
    "remindDelete": "The shape library is going to be cleared. This operation cannot be undone.",
    "emptyText": "",
    "deleteNewDb": "Clear this library",
    "clear": "Clear"
  },
  "fr": {
    "name": "Nom de bibliothèque de symboles",
    "title": "Modifier la bibliothèque de symboles",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "del": "Supprimer",
    "importMenu": "Importer",
    "loading": "chargement...",
    "nullName": "Nom de la bibliothèque ne peut pas être vide",
    "repeatedName": "Le nom de la bibliothèque ne peut pas être répété",
    "remindDelete": "La bibliothèque de formes va être effacée. Cette opération ne peut pas être annulée.",
    "deleteNewDb": "Effacez",
    "clear": "effacer"
  },
  "de": {
    "name": "Symbolbibliothek",
    "title": "Symbolbibliothek bearbeiten",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "del": "Löschen",
    "importMenu": "Importieren",
    "loading": "Wird geladen...",
    "nullName": "Bibliothekname darf nicht leer sein",
    "repeatedName": "Bibliotheksname darf nicht wiederholt sein",
    "remindDelete": "Die Formenbibliothek wird gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "deleteNewDb": "Löschen",
    "clear": "löschen"
  },
  "jp": {
    "name": "名前",
    "title": "タイトル",
    "confirm": "OK",
    "cancel": "キャンセル",
    "del": "削除",
    "importMenu": "インポート",
    "loading": "読み込み中...",
    "nullName": "ライブラリ名は空にできません",
    "repeatedName": "同じライブラリ名を繰り返し使用することはできません ",
    "remindDelete": "形状のライブラリはクリアされます。この操作は元に戻すことができません。",
    "deleteNewDb": "クリア",
    "clear": "クリア"
  },
  "es": {
    "name": "Nombre de la biblioteca de símbolos",
    "title": "Editar biblioteca de símbolos",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "del": "Eliminar",
    "importMenu": "Importación",
    "loading": "cargando...",
    "nullName": "Nombre de la biblioteca no puede estar vacío",
    "repeatedName": "El nombre de la biblioteca no se puede repetir",
    "remindDelete": "La biblioteca de formas se va a borrar. Esta operación no se puede deshacer.",
    "deleteNewDb": "Borra",
    "clear": "borrar"
  },
  "pt": {
    "name": "nome",
    "title": "Editar Biblioteca de Símbolos",
    "confirm": "OK",
    "cancel": "Cancelar",
    "del": "Eliminar",
    "importMenu": "Importar",
    "loading": "Carregando...",
    "nullName": "Nome de Biblioteca não pode estar vazia.",
    "repeatedName": "O nome da biblioteca não pode ser repetido.",
    "remindDelete": "A biblioteca de formas será apagada. Esta operação não pode ser desfeita.",
    "deleteNewDb": "Limpe",
    "clear": "limpar"
  },
  "it": {
    "name": "Nome",
    "title": "Modifica libreria di simboli",
    "confirm": "OK",
    "cancel": "Annulla",
    "del": "Elimina",
    "importMenu": "Importa",
    "loading": "Caricamento in corso...",
    "nullName": "Si prega di selezionare un nome per la libreria.",
    "repeatedName": "Il nome della libreria non può essere ripetuto",
    "remindDelete": "La libreria di forme sarà cancellata. Questa operazione non può essere annullata.",
    "deleteNewDb": "Cancella",
    "clear": "cancellare"
  },
  "tw": {
    "name": "符號庫名稱",
    "title": "編輯符號庫",
    "confirm": "確定",
    "cancel": "取消",
    "del": "刪除",
    "importMenu": "匯入",
    "loading": "載入中...",
    "nullName": "庫名不能為空",
    "repeatedName": "庫名不可重複",
    "remindDelete": "形狀庫將被清除。此操作無法撤銷。",
    "deleteNewDb": "清除這個庫",
    "clear": "清除"
  },
  "kr": {
    "name": "심볼 라이브러리 이름",
    "title": "심볼 라이브러리 편집",
    "confirm": "확인 ",
    "cancel": "취소 ",
    "del": "삭제 ",
    "importMenu": "가져오기",
    "loading": "로드 중...",
    "nullName": "라이브러리 이름은 비워 둘 수 없습니다.",
    "repeatedName": "라이브러리 이름은 반복할 수 없습니다.",
    "remindDelete": "도형 라이브러리가 지워질 예정입니다. 이 작업은 취소할 수 없습니다.",
    "deleteNewDb": "지우기",
    "clear": "지우다"
  }
}
</i18n>
